import AddMovieForm from "../components/AddMovieForm/AddMovieForm";
import Hero from "../components/Hero/Hero";

function CreateMovie(){
    return (
        <>
            <Hero />
            <AddMovieForm />
        </>
    );
}

export default CreateMovie;